import { logNewRelicPageAction } from '@makemydeal/dr-activities-common';

export enum ManualVppEventName {
    PRODUCT_EDITED = 'ManualVPP - Product Edited',
    PRODUCT_DELETED = 'ManualVPP - Product Deleted',
    PRODUCT_VALIDATED = 'ManualVPP - Product Validated',
    PRODUCTS_SET = 'ManualVPP - Products Set',
    CTA_CLICKED = 'ManualVPP - CTA Clicked'
}

type ManualVppEventAttributes = {
    dealerId?: number;
    dealXgId?: string;
    referrer?: string;
    productId?: string;
    productName?: string;
    productType?: string;
    productCost?: number;
    productPrice?: number;
    productCode?: string;
    profitLocation?: string;
    isValid?: boolean;
    validationErrors?: string[];
    productsCount?: number;
    inputField?: string;
    newValue?: string | number;
    ctaType?: 'Add From Catalog' | 'Add Manually';
};

/**
 * Log Manual VPP related events to New Relic
 * @param eventName - The name of the event from ManualVppEventName enum
 * @param attributes - Event-specific attributes
 */
export const logManualVppEvent = (eventName: ManualVppEventName, attributes: ManualVppEventAttributes = {}) => {
    logNewRelicPageAction(eventName, {
        ...attributes,
        timestamp: Date.now()
    });
};
